import { Pipe, PipeTransform } from '@angular/core';
import { RenderedListCardInfo } from './iq-builder-audit-tools.component';

@Pipe({
    name: 'sortActions',
    standalone: true,
})
export class SortActionsPipe implements PipeTransform {
    transform(
        value: { value: string; label: string }[],
        ...args: unknown[]
    ): { value: string; label: string }[] {
        return value.sort((a, b) => a.label.localeCompare(b.label));
    }
}
